import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import { apiSlice } from "./apiSlice";
import searchReducer from "./search/searchSlice";
import companyReducer from "./Company/companySlice";
import enterpriseReducer from "./enterprise/enterpriseSlice";
import claimsReducer from "./claim/claimSlice";
import activeTabReducer from "./activeTabSlice";
import activeCompanyReducer from "./activeCompanySlice";
import handle401Middleware from "../middleware/handle401Middleware";

// Function to load state from local storage
// const loadState = () => {
//   try {
//     const serializedState = localStorage.getItem('state');
//     if (serializedState === null) {
//       return undefined;
//     }
//     return JSON.parse(serializedState);
//   } catch (err) {
//     return undefined;
//   }
// };

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    const state = JSON.parse(serializedState);
    return {
      claims: state.claims,
      auth: state.auth,
      // search: state.search,
      company: state.company,
      enterprise: state.enterprise,
      activeTab: state.activeTab,
    };
  } catch (err) {
    return undefined;
  }
};

// Function to save state to local storage
const saveState = (state) => {
  try {
    const stateToPersist = {
      claims: state.claims,
      auth: state.auth,
      // search: state.search,
      company: state.company,
      enterprise: state.enterprise,
      activeTab: state.activeTab,
    };
    const serializedState = JSON.stringify(stateToPersist);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore write errors
  }
};
const persistedState = loadState();
const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    search: searchReducer,
    company: companyReducer,
    enterprise: enterpriseReducer,
    claims: claimsReducer,
    activeTab: activeTabReducer,
    activeCompany: activeCompanyReducer,
  },
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

// Save state to local storage on page unload
window.addEventListener('beforeunload', () => {
  saveState(store.getState());
});

// Clear the state from local storage after rehydrating
if (persistedState) {
  localStorage.removeItem('state');
}

export default store;
